module.exports = __webpack_public_path__ + "772014bd669c4fefb132b71ab9764590.png";